module.exports = __webpack_public_path__ + "img/bg80.f1b9a631.png";